import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { InsuranceDto } from '.';

export class AllInsurancesResponseModel extends GlobalResponseObject {
    data?: InsuranceDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: InsuranceDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

